import PropTypes from 'prop-types';
import React from 'react';
import bn from '../../utils/bemnames';
import ErrorBoundary from './ErrorBoundary';

const bem = bn.create('checkbox');

const CheckboxComponent = ({
  checkBoxClassName = '',
  checked = false,
  disabled = false,
  id = null,
  labelClassName = '',
  labelName = '',
  onChange = () => {},
}) => (
  <ErrorBoundary>
    <div className={bem.b('')}>
      <label
        htmlFor={id}
        className={
          labelClassName !== undefined
            ? disabled
              ? `${labelClassName} text-disable`
              : labelClassName
            : disabled
              ? 'col-form-label text-primary font-weight-bold text-disable'
              : 'col-form-label text-primary font-weight-bold'
        }
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className={checkBoxClassName === undefined ? 'form-check-input p-2 me-2' : checkBoxClassName}
          disabled={disabled}
          id={id}
        />
        {labelName}
      </label>
    </div>
  </ErrorBoundary>
);

CheckboxComponent.propTypes = {
  checkBoxClassName: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  labelClassName: PropTypes.string,
  labelName: PropTypes.string,
  onChange: PropTypes.func,
};

export default React.memo(CheckboxComponent);
